"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _NavSettings = _interopRequireDefault(require("../../NavSettings/NavSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  content: {
    position: "relative",
    "& [data-name=description]": {
      marginTop: theme.spacing(2)
    }
  },
  navSettings: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    margin: theme.spacing(.75)
  }
}));

const KioskLinkContent = (_ref) => {
  let _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      settings = _ref.settings,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["spacing", "settings", "children"]);

  const classes = useStyles();
  return _react.default.createElement("section", {
    className: classes.content,
    "data-name": "content"
  }, children, _react.default.createElement(_NavSettings.default, {
    className: classes.navSettings,
    settings: settings
  }));
};

var _default = KioskLinkContent;
exports.default = _default;
module.exports = exports.default;